import * as types from "../../mutation-types";

const mutations = {
  [types.SET_WORKS]: (state, payload) => {
    state.works = payload;
  },
  [types.SET_WORK]: (state, payload) => {
    state.work = payload;
  },
}

export default mutations;
